
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import LazyImage from "@src/components/LazyImage";
import WaitingTimeListBox from "@src/components/WaitingTimeListBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import {
  harajukuTakeoutBagDrinkImage,
  harajukuTakeoutBreadImage,
  harajukuTakeoutBurgerTakeoutImage,
  harajukuTakeoutKisurinTaketoutImage,
  harajukuTakeoutKisurinAppearanceImage,
  harajukuTakeoutMokubazaCurryImage,
  harajukuTakeoutMokubazaAppearanceImage,
  harajukuTakeoutNaprePizzaKalinImage,
  harajukuTakeoutNaprePizzaImage,
  harajukuTakeoutTopImage,
} from "@src/constants/images";
import { murakamiMasanori } from "@src/constants/authors";
import { meta as harajukuPageMeta } from "./index.mdx";
import { meta as theGreatBurgerPageMeta } from "./the_great_burger.mdx";
import { meta as mokubazaPageMeta } from "./mokubaza.mdx";
import { meta as naprePageMeta } from "./napre.mdx";
export const meta = {
  path: "/media/harajuku/takeout",
  title: "【食べログ3.7以上】原宿・表参道でテイクアウトができるの行列店５選",
  description: "コロナの影響で飲飲食店に足を運べないことも増えたと思いますが、もう自炊にもデリバリーにも飽きたりしていませんか？そんな時だからこそ、普段は行列で足を運べないけど、原宿・表参道でテイクアウトができる行列のお店をご紹介します！期間限定のお店もあるのでチェックしてください！",
  topImg: harajukuTakeoutTopImage,
  author: murakamiMasanori,
  tags: ["行列店", "原宿", "人気店", "まとめ記事", "テイクアウト", "行列情報"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`【ピザ】ナプレ 南青山店`}</h2>
    <LazyImage img={harajukuTakeoutNaprePizzaKalinImage} alt="abc" mdxType="LazyImage" />
    <p>{`日本で初めナポリピザを提供した日本ナポリピザの開拓者で、休日は連日行列が並んでいます。
イタリアから釜職人を呼び寄せて作った窯で、イタリアの大会で優勝したピザ職人が作るピザをテイクアウト可能！
外はカリッと、中はジューシーな味わいが楽しめます！`}</p>
    <p>{`食材もイタリアの現地から取り寄せ、本場のイタリア人も「現地より美味しい！」と絶賛するほど！`}</p>
    <LazyImage img={harajukuTakeoutNaprePizzaImage} alt="abc" mdxType="LazyImage" />
    <WaitingTimeListBox waitingTimes={["テイクアウト可能時間", "-11:30~14:30", "普段の行列時間", "-30~60分"]} mdxType="WaitingTimeListBox" />
    <LinkWithThumbnail meta={naprePageMeta} mdxType="LinkWithThumbnail" />
    <h2>{`【中華】希須林`}</h2>
    <LazyImage img={harajukuTakeoutKisurinAppearanceImage} alt="abc" mdxType="LazyImage" />
    <p>{`2020 年 4 月 6 日よりランチメニューのテイクアウトを開始した、原宿で女性に人気の中華の行列店です！
主菜が選べる「日替わりのランチボックス」(2 種類) と「炒飯のランチボックス」の計 3 種類が、
なんと税込 1000 円でテイクアウトできます！`}</p>
    <LazyImage img={harajukuTakeoutKisurinTaketoutImage} alt="abc" mdxType="LazyImage" />
    <p>{`雨の日でも行列ができるお店になっているので、期間限定でテイクアウトができる時期に試してみてください！`}</p>
    <WaitingTimeListBox waitingTimes={["アクセス", "-表参道駅から徒歩５分", "テイクアウト可能時間", "-11:30~14:00", "普段の行列時間", "-30~60分"]} mdxType="WaitingTimeListBox" />
    <h2>{`【バーガー】ザ グレートバーガー`}</h2>
    <LazyImage img={harajukuTakeoutBurgerTakeoutImage} alt="abc" mdxType="LazyImage" />
    <p>{`原宿で道ゆく人に、「原宿のハンバーガーといえば？」と聞けば必ず出てくるのが、ザグレートバーガー。
オーナーが半年間試行錯誤して作り上げたバンズ(パン)は、カリッとした食感の後にフワフワがあります。
Take Out Lunch Box は、好きなハンバーガーと、フライドポテトのセットを箱詰めにして、900 円。
ポテトは無料で L に変更可能。ドリンクは＋ 100 円で追加できて、店内で食べるよりもお得に！`}</p>
    <WaitingTimeListBox waitingTimes={["アクセス", "-原宿から徒歩５分", "テイクアウト可能時間", "-11:30~15:00", "普段の行列時間", "-30~60分"]} mdxType="WaitingTimeListBox" />
    <LinkWithThumbnail meta={theGreatBurgerPageMeta} mdxType="LinkWithThumbnail" />
    <h2>{`【パン】パンとエスプレッソと`}</h2>
    <LazyImage img={harajukuTakeoutBagDrinkImage} alt="abc" mdxType="LazyImage" />
    <p>{`白を基調としたスタイリッシュな外観で表参道に佇み、若い女性の間で人気のお店です。
特徴的な頃のロゴを見たことがある方も多いのではないでしょうか？`}</p>
    <p>{`何もつけずに食べられる食パン「ムー」や、独特な組み合わせ「あんこクリームチーズ」「アールグレイメロンパン」など、
一度は味を確かめてみたい！と思わせるメニューがたくさん！`}</p>
    <p>{`普段は行列ができることもあるので、この機会にテイクアウトしてみてはいかがでしょうか？`}</p>
    <LazyImage img={harajukuTakeoutBreadImage} alt="abc" mdxType="LazyImage" />
    <WaitingTimeListBox waitingTimes={["アクセス", "-表参道(A2)から徒歩５分", "テイクアウト可能時間", "-営業時間　8:00～20:00", "普段の行列時間", "-30分"]} mdxType="WaitingTimeListBox" />
    <h2>{`【カレー】MOKUBAZA`}</h2>
    <LazyImage img={harajukuTakeoutMokubazaAppearanceImage} alt="abc" mdxType="LazyImage" />
    <p><strong parentName="p">{`20 時間かけて作られた芸術的な見た目のカレーに魅了されて、平日でも行列ができるほどのカレーの名店。`}</strong>{`
素材の味を生かして調理されており、またテイクアウトでも色んなメニューとトッピングが楽しめます！`}</p>
    <p>{`有名人も訪れることもあるらしく、一度は訪れて人に自慢したくなる、そんな一品です！`}</p>
    <LazyImage img={harajukuTakeoutMokubazaCurryImage} alt="abc" mdxType="LazyImage" />
    <p>{`チーズと卵は 商品の性質上お持ち帰り出来ないそうなのですが、
普段行列に並べない人でも、キーマカレー本来の味をテイクアウトで堪能してみてください！`}</p>
    <WaitingTimeListBox waitingTimes={["アクセス", "-原宿駅より徒歩９分", "テイクアウト可能時間", "-営業時間　8:00～20:00", "普段の行列時間", "-60分"]} mdxType="WaitingTimeListBox" />
    <LinkWithThumbnail meta={mokubazaPageMeta} mdxType="LinkWithThumbnail" />
    <h3>{`おわりに`}</h3>
    <p>{`今回は、コロナの状況でも絶品ランチを食べれるテイクアウト可能な行列店をピックアップしてまとめました。`}</p>
    <p>{`また、コロナが落ち着いたら行きたい`}<strong parentName="p">{`原宿の行列ランチについては下記の記事でまとめています`}</strong>{`ので、是非ご覧ください！`}</p>
    <LinkWithThumbnail meta={harajukuPageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;